<template>
  <el-container>
    <el-aside width="150px"></el-aside>
    <el-main style="margin-top: 70px;margin-bottom: 40px;">
        <el-menu default-active="1" class="el-menu-vertical-demo" @select="handleSelect" style="">
          <el-menu-item index="1">What is Dev Enhancer?</el-menu-item>
          <el-menu-item index="2">Home</el-menu-item>
          <el-menu-item index="3">Search</el-menu-item>
          <el-menu-item index="4">Analysis</el-menu-item>
          <el-menu-item index="5">Genome Browser</el-menu-item>
          <el-menu-item index="6">Statistics</el-menu-item>
        </el-menu>
        <div style="margin-left: 100px;">
        <el-row :gutter="20" id="WhatSection">
          <h1 style="color: #0F1035;font-weight: bold;border-bottom: 2px solid #808080;"><i class="el-icon-location"></i>What is Dev Enhancer?</h1>
          <img src="../../static/image/workflow.png" alt="loading" class="test" style="box-shadow: 0px 0px 5px #808080; border-radius: 10px;">
          <div class="paragraph">
            <p><span style="color: #B16900;text-align: center;"><em>DevEnhancer</em></span> aims to assist researchers in understanding the enhancers and their regulatory mechanisms during the development processes of humans and mice. We focus on core enhancers and collect, process, and analyze public data. 
              By building a fully functional platform, we provide query, analysis, and tool modules to help users effectively explore and interpret data.
            </p>
          </div>
        </el-row>
        <el-row :gutter="20" style="margin-top: 20px;" id="homeSection">
          <h1 style="color: #0F1035;font-weight: bold;border-bottom: 2px solid #808080;"><i class="el-icon-location"></i>Home</h1>
          <img src="../../static/image/home.png" alt="loading" class="test" style="box-shadow: 0px 0px 5px #808080; border-radius: 10px;">
          <div class="paragraph">
            <p><span style="color: red;">Sec. 1</span> is the navigation bar, which includes modules such as "Home", "Search", "Analysis", "Genome Browser", "Statistics", "Contact", and "Help".</p>
            <p><span style="color: red;">Sec. 2</span> is the section about the database name and description.</p>
            <p><span style="color: red;">Sec. 3</span> are shortcut buttons that can display different visualization content.</p>
            <p><span style="color: red;">Sec. 4</span> is a carousel displaying some results of this platform.</p>
            <p><span style="color: red;">Sec. 5</span> is the bottom bar, which, when clicked, redirects to the research institute to which this platform belongs.</p>
          </div>
        </el-row>
        <el-row :gutter="20" style="margin-top: 20px;" id="searchSection">
          <h1 style="color: #0F1035;font-weight: bold;border-bottom: 2px solid #808080;"><i class="el-icon-location"></i>Search</h1>
          <div class="paragraph">
            <p>This module includes several functional modules such as <span style="color: red;">Enhancer List</span>, <span style="color: red;">Enhancer Feature</span>, <span style="color: red;">SE-coreEnhancer</span>,
               <span style="color: red;">TFs-Enhancer-Genes</span>, <span style="color: red;">Enhancers-TFs</span>, <span style="color: red;">Enhancers-Genes</span>, and <span style="color: red;">3D Genome</span>.</p>
          </div>
          <div>
            <el-container>
              <el-aside width="70%"><img src="../../static/image/Enhancerlist.png" alt="loading" class="test" style="box-shadow: 0px 0px 5px #808080; border-radius: 10px;"></el-aside>
              <el-main width="70%">
                <h3><i style="color: red;">&#9658;</i> Enhancer List</h3>
                <div class="paragraph">
                  <p>This module allows users to browse enhancer information for specific species and tissues.</p>
                  <p><i class="bm-list">1</i>Users can select their interested type, species, and tissue through the selection box.</p>
                  <p><i class="bm-list">2</i>When the mouse hovers over, it will display the corresponding enhancer sequence information.</p>
                  <p><i class="bm-list">3</i>Click the button to download the corresponding enhancer list.</p>
                  <p><i class="bm-list">4</i>Clicking on the pagination component allows browsing through the data.</p>
                </div>
              </el-main>
            </el-container>
          </div>
          <div>
            <el-container>
              <el-aside width="70%"><img src="../../static/image/Enhancerfeature.png" alt="loading" class="test" style="box-shadow: 0px 0px 5px #808080; border-radius: 10px;"></el-aside>
              <el-main width="70%">
                <h3><i style="color: red;">&#9658;</i> Enhancer Feature</h3>
                <div class="paragraph">
                  <p>In this module, users can view enhancer features for species and tissues of interest.</p>
                  <p><i class="bm-list">1</i>Users can select their interested type, species, and tissue through the selection box.</p>
                  <p><i class="bm-list">2</i>It displays the chromosomal distribution of enhancers.</p>
                  <p><i class="bm-list">3</i>It shows the genomic annotation information of enhancers.</p>
                </div>
              </el-main>
            </el-container>
          </div>
          <div>
            <el-container>
              <el-aside width="70%"><img src="../../static/image/SE_En.png" alt="loading" class="test" style="box-shadow: 0px 0px 5px #808080; border-radius: 10px;"></el-aside>
              <el-main width="70%">
                <h3><i style="color: red;">&#9658;</i> SE-coreEnhancer</h3>
                <div class="paragraph">
                  <p>In this module, users can see the relationship between core enhancers and super-enhancers.</p>
                  <p><i class="bm-list">1</i>Users can select their interested species, and tissue through the selection box.</p>
                  <p><i class="bm-list">2</i>The Sankey diagram displays the relationship between core enhancers and super-enhancers.</p>
                  <p><i class="bm-list">3</i>Clicking on the two buttons allows you to navigate forward or backward through the visualized data.</p>
                  <p><i class="bm-list">4</i>List of relationships between core enhancers and super-enhancers.</p>
                  <p><i class="bm-list">5</i>Click the button to download the site information corresponding to core enhancers and super-enhancers.</p>
                  <p><i class="bm-list">6</i>Click on the pagination component to browse the data.</p>
                </div>
              </el-main>
            </el-container>
          </div>
          <div>
            <el-container>
              <el-aside width="70%"><img src="../../static/image/TF_enhancer_gene.png" alt="loading" class="test" style="box-shadow: 0px 0px 5px #808080; border-radius: 10px;"></el-aside>
              <el-main width="70%">
                <h3><i style="color: red;">&#9658;</i> TFs-Enhancer-Genes</h3>
                <div class="paragraph">
                  <p>In this module, users can view enhancer transcription factor binding sites, target genes, and regulatory relationships.</p>
                  <p><i class="bm-list">1</i>Users can select their interested species, and tissue through the selection box.</p>
                  <p><i class="bm-list">2</i>This Sankey diagram illustrates the regulatory relationships between transcription factors, enhancers, and genes.</p>
                  <p><i class="bm-list">3</i>Clicking on the two buttons allows you to navigate forward or backward through the visualized data.</p>
                  <p><i class="bm-list">4</i>Transcription factors and target genes corresponding to enhancers.</p>
                  <p><i class="bm-list">5</i>Click the button to download the list of transcription factors and target genes corresponding to enhancers.</p>
                  <p><i class="bm-list">6</i>Click on the pagination component to browse the data.</p>
                </div>
              </el-main>
            </el-container>
          </div>
          <div>
            <el-container>
              <el-aside width="70%"><img src="../../static/image/enhancerTF.png" alt="loading" class="test" style="box-shadow: 0px 0px 5px #808080; border-radius: 10px;"></el-aside>
              <el-main width="70%">
                <h3><i style="color: red;">&#9658;</i> Enhancer-TFs</h3>
                <div class="paragraph">
                  <p>In this module, users can view the protein-protein interaction (PPI) and expression levels of transcription factors associated with enhancers.</p>
                  <p><i class="bm-list">1</i>Users can select their interested species, and tissue through the selection box.</p>
                  <p><i class="bm-list">2</i>This network diagram illustrates the interaction network of transcription factors associated with enhancers.</p>
                  <p><i class="bm-list">3</i>This bar chart displays the expression levels of transcription factors associated with enhancers.</p>
                </div>
              </el-main>
            </el-container>
          </div>
          <div>
            <el-container>
              <el-aside width="70%"><img src="../../static/image/enhancerGene.png" alt="loading" class="test" style="box-shadow: 0px 0px 5px #808080; border-radius: 10px;"></el-aside>
              <el-main width="70%">
                <h3><i style="color: red;">&#9658;</i> Enhancer-Genes</h3>
                <div class="paragraph">
                  <p>In this module, users can view the protein-protein interaction (PPI) and expression levels of genes associated with enhancers.</p>
                  <p><i class="bm-list">1</i>Users can select their interested species, and tissue through the selection box.</p>
                  <p><i class="bm-list">2</i>This network diagram illustrates the interaction network of genes associated with enhancers.</p>
                  <p><i class="bm-list">3</i>This bar chart displays the expression levels of genes associated with enhancers.</p>
                </div>
              </el-main>
            </el-container>
          </div>
          <div>
            <el-container>
              <el-aside width="70%"><img src="../../static/image/3D.png" alt="loading" class="test" style="box-shadow: 0px 0px 5px #808080; border-radius: 10px;"></el-aside>
              <el-main width="70%">
                <h3><i style="color: red;">&#9658;</i> 3D Genome</h3>
                <div class="paragraph">
                  <p>This module presents information about compartments, TADs (Topologically Associating Domains), and loops in the three-dimensional genome.</p>
                  <p><i class="bm-list">1</i>Users can select their interested type, species, and tissue through the selection box.</p>
                  <p><i class="bm-list">2</i>This pie chart displays the proportion of A/B compartments.</p>
                  <p><i class="bm-list">3</i>This chart displays the chromosomal distribution information of the 3D genome.</p>
                  <p><i class="bm-list">4</i>This scatter plot displays the sizes of TADs and loops.</p>
                  <p><i class="bm-list">5</i>List of information about the 3D genome.</p>
                  <p><i class="bm-list">6</i>Click the button to download the list of 3D genome information.</p>
                  <p><i class="bm-list">7</i>Click on the pagination component to browse the 3D genome information.</p>
                </div>
              </el-main>
            </el-container>
          </div>
        </el-row>
        <el-row :gutter="20" style="margin-top: 20px;" id="analysisSection">
          <h1 style="color: #0F1035;font-weight: bold;border-bottom: 2px solid #808080;"><i class="el-icon-location"></i>Analysis</h1>
          <div class="paragraph">
            <p>The "Analysis" module in the navigation bar covers a variety of functionalities, including 
                Enhancer Quantity Comparison (<span style="color:red;">EnhancerQuant Compare</span>), 
                Enhancer Transcription Factor Expression Comparison (<span style="color:red;">EnhancerTF Compare</span>), 
                Enhancer Target Gene Expression Comparison (<span style="color:red;">EnhancerGene Compare</span>), 
                Gene Ontology and Pathway Analysis (<span style="color:red;">GO/KEGG Analysis</span>), 
                as well as three tools supporting file uploads for analysis: 
                Overlap Analysis of Enhancers, Identification of the Closest Gene, and Motif Conversion.</p>
          </div>
          <div>
            <el-container>
              <el-aside width="70%"><img src="../../static/image/number.png" alt="loading" class="test" style="box-shadow: 0px 0px 5px #808080; border-radius: 10px;"></el-aside>
              <el-main width="70%">
                <h3><i style="color: red;">&#9658;</i> EnhancerQuant Compare</h3>
                <div class="paragraph">
                  <p>This module displays the number of enhancers corresponding to specific species' developmental processes.</p>
                  <p><i class="bm-list">1</i>Users can select their interested species, and developmental process through the selection box.</p>
                  <p><i class="bm-list">2</i>The module showcases the number of enhancers corresponding to specific species' developmental processes.</p>
                  <p><i class="bm-list">3</i>There are three types of enhancers, and users can click to select which types to display.</p>
                </div>
              </el-main>
            </el-container>
          </div>
          <div>
            <el-container>
              <el-aside width="70%"><img src="../../static/image/TFexpression.png" alt="loading" class="test" style="box-shadow: 0px 0px 5px #808080; border-radius: 10px;"></el-aside>
              <el-main width="70%">
                <h3><i style="color: red;">&#9658;</i> EnhancerTF Compare</h3>
                <div class="paragraph">
                  <p>This module showcases the transcription factor expression levels during the developmental processes of specific species.</p>
                  <p><i class="bm-list">1</i>Users can select their interested species, and developmental process through the selection box.</p>
                  <p><i class="bm-list">2</i>This module displays the expression levels of transcription factors during the developmental processes of specified species.</p>
                  <p><i class="bm-list">3</i>The drag-and-drop component allows users to select specific transcription factors to display their expression levels.</p>
                  <p><i class="bm-list">4</i>Users can click on these two buttons to select the image format for downloading, including SVG and PNG.</p>
                </div>
              </el-main>
            </el-container>
          </div>
          <div>
            <el-container>
              <el-aside width="70%"><img src="../../static/image/geneexpression.png" alt="loading" class="test" style="box-shadow: 0px 0px 5px #808080; border-radius: 10px;"></el-aside>
              <el-main width="70%">
                <h3><i style="color: red;">&#9658;</i> EnhancerGene Compare</h3>
                <div class="paragraph">
                  <p>This module showcases the genes expression levels during the developmental processes of specific species.</p>
                  <p><i class="bm-list">1</i>Users can select their interested species, and developmental process through the selection box.</p>
                  <p><i class="bm-list">2</i>This module displays the expression levels of genes during the developmental processes of specified species.</p>
                  <p><i class="bm-list">3</i>The drag-and-drop component allows users to select specific genes to display their expression levels.</p>
                  <p><i class="bm-list">4</i>Users can click on these two buttons to select the image format for downloading, including SVG and PNG.</p>
                </div>
              </el-main>
            </el-container>
          </div>
          <div>
            <el-container>
              <el-aside width="70%"><img src="../../static/image/Gokegg.png" alt="loading" class="test" style="box-shadow: 0px 0px 5px #808080; border-radius: 10px;"></el-aside>
              <el-main width="70%">
                <h3><i style="color: red;">&#9658;</i> GO/KEGG Analysis</h3>
                <div class="paragraph">
                  <p>This module displays the GO and KEGG analysis results corresponding to the specified species and tissue.</p>
                  <p><i class="bm-list">1</i>Users can display corresponding results by selecting GO or KEGG, species, and tissue.</p>
                  <p><i class="bm-list">2</i>Here are the results corresponding to the options of GO, human, and hESC.</p>
                </div>
              </el-main>
            </el-container>
          </div>
          <div>
            <el-container>
              <el-aside width="70%"><img src="../../static/image/overlap.png" alt="loading" class="test" style="box-shadow: 0px 0px 5px #808080; border-radius: 10px;"></el-aside>
              <el-main width="70%">
                <h3><i style="color: red;">&#9658;</i> Overlap Analysis of Enhancers</h3>
                <div class="paragraph">
                  <p>This module allows users to upload BED files for overlap analysis.</p>
                  <p><i class="bm-list">1</i>Click the "select file" button to upload Target File 1.</p>
                  <p><i class="bm-list">2</i>Click the "select file" button to upload Target File 2.</p>
                  <p><i class="bm-list">3</i>Click the "analysis" button to automatically analyze.</p>
                </div>
              </el-main>
            </el-container>
          </div>
          <div>
            <el-container>
              <el-aside width="70%"><img src="../../static/image/cloestgene.png" alt="loading" class="test" style="box-shadow: 0px 0px 5px #808080; border-radius: 10px;"></el-aside>
              <el-main width="70%">
                <h3><i style="color: red;">&#9658;</i> Identification of the Closest Gene</h3>
                <div class="paragraph">
                  <p>In this module, users can input text or upload BED files to identify the closest of target regions.</p>
                  <p><i class="bm-list">1</i>Select the corresponding species.</p>
                  <p><i class="bm-list">2</i>Select the region text or file mode.</p>
                  <p><i class="bm-list">3</i>Enter text or select a file.</p>
                  <p><i class="bm-list">4</i>Identify closest genes.</p>
                </div>
              </el-main>
            </el-container>
          </div>
          <div>
            <el-container>
              <el-aside width="70%"><img src="../../static/image/motif.png" alt="loading" class="test" style="box-shadow: 0px 0px 5px #808080; border-radius: 10px;"></el-aside>
              <el-main width="70%">
                <h3><i style="color: red;">&#9658;</i> Motif Conversion</h3>
                <div class="paragraph">
                  <p>This module is used to process the results after Homer analysis.</p>
                  <p><i class="bm-list">1</i>Select a file in TXT format.</p>
                  <p><i class="bm-list">2</i>Click the "convert" button to complete the process.</p>
                </div>
              </el-main>
            </el-container>
          </div>
        </el-row>
        <el-row :gutter="20" style="margin-top: 20px;" id="genomeSection">
          <h1 style="color: #0F1035;font-weight: bold;border-bottom: 2px solid #808080;"><i class="el-icon-location"></i>Genome Browser</h1>
          <div>
            <el-container>
              <el-aside width="70%"><img src="../../static/image/genome.png" alt="loading" class="test" style="box-shadow: 0px 0px 5px #808080; border-radius: 10px;"></el-aside>
              <el-main width="70%">
                <h3><i style="color: red;">&#9658;</i> Genome Browser</h3>
                <div class="paragraph">
                  <p>This module is used to display peak signals from multi-omics data and to perform comparison and analysis.</p>
                  <p><i class="bm-list">1</i>Users can select the reference genome.</p>
                  <p><i class="bm-list">2</i>Users can select the developmental process.</p>
                  <p><i class="bm-list">3</i>Clicking on the position of the gene displays specific information.</p>
                </div>
              </el-main>
            </el-container>
          </div>
        </el-row>
        <el-row :gutter="20" style="margin-top: 20px;" id="statisticSection">
          <h1 style="color: #0F1035;font-weight: bold;border-bottom: 2px solid #808080;"><i class="el-icon-location"></i>Statistics</h1>
          <div>
            <el-container>
              <el-aside width="70%"><img src="../../static/image/statistics.png" alt="loading" class="test" style="box-shadow: 0px 0px 5px #808080; border-radius: 10px;"></el-aside>
              <el-main width="70%">
                <h3><i style="color: red;">&#9658;</i> Statistics</h3>
                <div class="paragraph">
                  <p>This module displays all the data used in this study.</p>
                  <p><i class="bm-list">1</i>The four pie charts display the contents of the data, including 2 species, 3 developmental stages, 4 types of omics data, and 109 tissues.</p>
                  <p><i class="bm-list">2</i>This list displays the raw data, including their corresponding GEO and ENCODE numbers. Clicking on them will redirect you to the detailed introduction of the data.</p>
                </div>
              </el-main>
            </el-container>
          </div>
        </el-row>
      </div>
    </el-main>
    <el-aside width="150px"></el-aside>
  </el-container>
</template>

<script>
export default {
  methods: {
    handleSelect(index) {
      const targetId = this.getTargetId(index);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        const offset = targetElement.offsetTop - 110; // 偏移量为70px + 40px，适应顶部导航栏和底部边距
        window.scrollTo({ top: offset, behavior: 'smooth' });
      }
    },
    getTargetId(index) {
      switch (index) {
        case '1':
          return 'WhatSection';
        case '2':
          return 'homeSection';
        case '3':
          return 'searchSection';
        case '4':
          return 'analysisSection';
        case '5':
          return 'genomeSection';
        case '6':
          return 'statisticSection';
        default:
          return '1';
      }
    },
  },
};
</script>

<style scoped>
.el-menu-vertical-demo{
  width: 200px; /* 调整菜单宽度以适应内容 */
  border-right: 3px dashed grey; /* 虚线右边框，3像素宽度，灰色 */
  position: fixed; 
  top: 50px; 
  left: 40px;
  margin-top: 20px;
}
.test{
  max-width: 100%;
  max-height: 100%;
  margin-top: 20px;
}
.paragraph{
  font-size: 20px;
  margin-top: 25px;
  color: #565f69;
  word-spacing:2px;
}
.paragraph p {
  margin-bottom: 8px; /* 可以根据需要调整间距大小 */
}
.bm-list {
  font-family: IBM Plex Sans;
  border-radius: 50%;
  margin: 0 8px 0 0;
  height: 25px;
  width: 25px;
  display: inline-block;
  color: #fff;
  background: red;
  line-height: 22px;
  text-align: center;
  border: 1px solid red;
  white-space: nowrap;
  padding: 1px 3px 1px 0;
  font-size: 16px;
  -webkit-transform: scale(.9);
  transform: scale(.9);
}

</style>



// WEBPACK FOOTER //
// src/components/Help.vue